module.exports = __webpack_public_path__ + "media/images/recipes/sukadelap-edc7ed128a0fb5d9fce9ab3faf8b44b1.pdf";